// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
}
.mainbackground {
  width: 100%;
  min-height: 100vh;
  padding-top: 6rem;
}
.mainbackground > .notCont {
  width: 90%;
  margin: 0 auto;
  padding-bottom: 4rem;
}
.mainbackground > .loginscheme {
  width: 90%;
  margin: 0 auto;
}
.mainbackground > .notification {
  width: 90%;
  margin: 0 auto;
  /* position: relative;
  top: 7rem; */
}
.mainbackground > .menu {
  width: 90%;
  margin: 0 auto;
  /* padding-top: 5rem; */
}
.mainbackground > .menu > div > .image {
  border-radius: 1rem;
  transform: rotate(-45deg);
}
.mainbackground > .menu > div > .image > img {
  height: 150px;
  width: 150px;
  transform: rotate(45deg);
  object-fit: contain;
}
.mainbackground > .registerLogo > .image {
  border-radius: 1rem;
  transform: rotate(-45deg);
}
.mainbackground > .registerLogo > .image > img {
  height: 150px;
  width: 150px;
  transform: rotate(45deg);
  object-fit: contain;
}
.mainbackground > .homeLogo > .image {
  border-radius: 1rem;
  transform: rotate(-45deg);
}
.mainbackground > .homeLogo > .image > img {
  height: 150px;
  width: 150px;
  transform: rotate(45deg);
  object-fit: contain;
}
.mainbackground > .menu > .content:nth-child(2) {
  width: 100%;
  border-bottom: 1px solid #4a4a4a;
}
.mainbackground > .menu > .content:nth-child(3) {
  width: 100%;
}
.mainbackground > .menu > .content:nth-child(3) > .apps > div {
  width: 100%;
}
.mainbackground > .menu > .content:nth-child(3) > .apps > a {
  width: 50%;
}
.mainbackground > .menu > .content:nth-child(3) > .apps > a > span {
  border-radius: 0.4rem;
}
.mainbackground
  > .menu
  > .content:nth-child(3)
  > div
  > .box
  > .table
  > tbody
  > tr
  > td:nth-child(2) {
  width: 30%;
}
.mainbackground > .menu > .box {
  width: 100%;
}
.mainbackground > .menu > .formsChange {
  width: 100%;
}
.mainbackground > .menu > .accountInfo {
  border-bottom: 1px solid #4a4a4a;
  width: 100%;
}
.mainbackground > .menu > .accountInfo > .buttons > div {
  width: 100%;
}
.mainbackground > .mobile > .modal-content {
  width: 90%;
  margin: 0 auto;
}
.mainbackground > .menu .adminConfMob {
  border-top: 1px solid #4a4a4a;
}

@media screen and (min-width: 1024px) {
  .mainbackground > .notCont {
    width: 50%;
    margin: 0 auto;
  }
  .mainbackground > .loginscheme {
    width: 40%;
    margin: 0 auto;
  }
  .mainbackground > .menuFullWidth {
    width: 100%;
    height: 100%;
  }
  .mainbackground > .menuFullWidth > .sideBar {
    position: fixed;
    padding-top: 6rem;
    top: 0;
    left: 0;
    width: 20%;
    min-height: 100vh;
  }
  .mainbackground > .menuFullWidth > .sideBar > .topSideBar {
    width: 100%;
  }
  .mainbackground > .menuFullWidth > .sideBar > .topSideBar > .image {
    border-radius: 1rem;
    transform: rotate(-45deg);
  }
  .mainbackground > .menuFullWidth > .sideBar > .topSideBar > .image > img {
    height: 100px;
    width: 100px;
    transform: rotate(45deg);
    object-fit: contain;
  }
  /* .mainbackground > .menuFullWidth > .sideBarRight {
    position: fixed;
    padding-top: 6rem;
    top: 0;
    left: 80%;
    width: 20%;
    min-height: 100vh;
  } */
  .mainbackground > .menuFullWidth > div {
    position: relative;
    left: 20%;
    width: 80%;
  }
  .mainbackground > .menuFullWidth > div > .content > .topTitle {
    border-bottom: 1px solid #4a4a4a;
  }
  .mainbackground > .menuFullWidth > div > .content > div {
    width: 100%;
  }
  .mainbackground > .menuFullWidth > div > .content > div > .image {
    border-radius: 1rem;
    transform: rotate(-45deg);
  }
  .mainbackground > .menuFullWidth > div > .content > div > .image > img {
    height: 200px;
    width: 200px;
    transform: rotate(45deg);
    object-fit: contain;
  }
  /* .mainbackground > .menuFullWidth > div > .content > .table {
    border-radius: 1rem;
  } */
  .mainbackground > .menuFullWidth > .content > div > .subtitle:nth-child(3) {
    border-bottom: 1px solid #4a4a4a;
  }
  /* .mainbackground > .menuFullWidth > .sideBar > .sidebarmenu {
    width: 90%;
    margin: 0 auto;
    padding-top: 1rem;
  }
  .mainbackground > .menuFullWidth > .sideBar > .sidebarmenu > .box {
    width: 90%;
    margin: 0 auto;
    cursor: pointer;
  } */
  .mainbackground > .menuFullWidth > .sideBar > .topSideBar > .asideMenu {
    width: 80% !important;
  }
  /* .mainbackground > .menuFullWidth > .sideBar > .sidebarmenu {
    border-top: 1px solid #4a4a4a;
    border-bottom: 1px solid #4a4a4a;
  }
  .mainbackground > .menuFullWidth > .sideBar > .sidebarmenu > .box:hover {
    background: #7a7a7a !important;
    transition: 0.3s ease-in-out;
  }
  .mainbackground > .menuFullWidth > .sideBar > .sidebarmenu > .selectedCard {
    background: #7a7a7a !important;
    transition: 0.3s ease-in-out;
  } */
  .mainbackground > .menuFullWidth > div > .content {
    width: 90%;
    margin: 0 auto;
  }
  .mainbackground > .menuFullWidth > div > .content > div > .box {
    border: 1px solid #4a4a4a;
    width: 60%;
  }
  .mainbackground > .menuFullWidth > div > .content > div > .adminConf {
    width: 30%;
  }
  .mainbackground
    > .menuFullWidth
    > div
    > .content
    > div
    > .adminConf
    > div
    > .explanation {
    width: 100%;
  }
  .mainbackground
    > .menuFullWidth
    > div
    > .content
    > div
    > .box
    > .table
    > tbody
    > tr
    > td:nth-child(1) {
    width: 70%;
  }
  .mainbackground > .menuFullWidth > div > .content > .box {
    width: 90%;
    margin: 0 auto;
  }
  .mainbackground > .menuFullWidth > div > .content > .buttons {
    /* width: 90%;
    margin: 0 auto; */
    border-top: 1px solid #4a4a4a;
  }
  .mainbackground > .menuFullWidth > div > .content > .apps > a > .icon-text {
    border-radius: 0.4rem;
  }
  .mainbackground
    > .menuFullWidth
    > div
    > .content
    > .box
    > form
    > .content
    > div {
    border-radius: 0.5rem;
  }
  .mainbackground
    > .menuFullWidth
    > .sideBar
    > div
    > .socialmedialinks
    > a
    > .icon-text:hover {
    /* background: #dbdbdb !important; */
    transition: 0.3s ease-in-out;
  }
  .mainbackground
    > .menuFullWidth
    > .sideBar
    > div
    > .socialmedialinks
    > a
    > .icon-text {
    border-radius: 0.3rem;
  }
  .mainbackground
    > .menuFullWidth
    > .sideBar
    > div
    > .socialmedialinks
    > a:nth-child(1)
    > .icon-text
    > .icon
    > svg {
    transform: scale(1.2, 1.2) !important;
    /* transition: 0.3s ease-in-out; */
  }
  .mainbackground
    > .menuFullWidth
    > .sideBar
    > div
    > .socialmedialinks
    > a
    > .icon-text {
    height: 39px !important;
    width: 39px !important;
  }
  .mainbackground
    > .menuFullWidth
    > .sideBar
    > div
    > .socialmedialinks
    > a
    > .icon-text
    > .icon {
    height: 100% !important;
    width: 100% !important;
  }
  .mainbackground
    > .menuFullWidth
    > .sideBar
    > div
    > .socialmedialinks
    > a
    > .icon-text
    > .icon
    > svg {
    height: 100% !important;
    width: 100% !important;
  }
  .mainbackground
    > .menuFullWidth
    > .sideBar
    > div
    > .socialmedialinks
    > a
    > .icon-text
    > .icon
    > svg
    > path {
    height: 100% !important;
    width: 100% !important;
  }
  .mainbackground
    > .menuFullWidth
    > .sideBar
    > div
    > .socialmedialinks
    > a:nth-child(2)
    > .icon-text
    > .icon {
    border-radius: 0.3rem;
    color: transparent;
    background: radial-gradient(
      circle at 30% 107%,
      #fdf497 0%,
      #fdf497 5%,
      #fd5949 45%,
      #d6249f 60%,
      #285aeb 90%
    ) !important;
    background: -webkit-radial-gradient(
      circle at 30% 107%,
      #fdf497 0%,
      #fdf497 5%,
      #fd5949 45%,
      #d6249f 60%,
      #285aeb 90%
    ) !important;
    background-clip: text;
    -webkit-background-clip: text;
  }
  .mainbackground
    > .menuFullWidth
    > .sideBar
    > div
    > .socialmedialinks
    > a:nth-child(2)
    > .icon-text
    > .icon
    > svg {
    color: #ffffff;
  }
  .mainbackground > .menuFullWidth > .sideBar > div {
    width: 100%;
  }
  .mainbackground > .menuFullWidth > .sideBar > div > .emailLink {
    width: 90%;
    margin: 0 auto;
    border-top: 1px solid #4a4a4a;
  }
  .mainbackground
    > .menuFullWidth
    > .sideBar
    > div
    > .emailLink
    > div
    > a
    > .icon-text {
    height: 39px !important;
    width: 39px !important;
  }
  .mainbackground
    > .menuFullWidth
    > .sideBar
    > div
    > .emailLink
    > div
    > a
    > .icon-text {
    border-radius: 0.4rem;
  }
  .mainbackground
    > .menuFullWidth
    > .sideBar
    > div
    > .emailLink
    > div
    > a
    > .icon-text
    > .icon {
    height: 100% !important;
    width: 100% !important;
  }
  .mainbackground
    > .menuFullWidth
    > .sideBar
    > div
    > .emailLink
    > div
    > a
    > .icon-text
    > .icon
    > svg {
    height: 100% !important;
    width: 90% !important;
  }
  .mainbackground > .menuFullWidth > .fullwidthAccount > .accountInfo {
    width: 90%;
    margin: 0 auto;
  }
  .mainbackground > .menuFullWidth > .fullwidthAccount > .accountInfo {
    border-bottom: 1px solid #4a4a4a;
  }
  .mainbackground
    > .menuFullWidth
    > .fullwidthAccount
    > .accountInfo
    > .buttons {
    width: 25%;
  }
  .mainbackground
    > .menuFullWidth
    > .fullwidthAccount
    > .accountInfo
    > .buttons
    > div {
    width: 100%;
  }
  .mainbackground > .menuFullWidth > .fullwidthAccount > .accountInfo > .box {
    width: 60%;
    border: 1px solid #4a4a4a;
  }
  .mainbackground
    > .menuFullWidth
    > .fullwidthAccount
    > .accountInfo
    > .box
    > .table
    > tbody
    > tr
    > td:nth-child(1) {
    width: 20%;
  }
  .mainbackground > .menuFullWidth > .fullwidthAccount > .formsChange {
    width: 90%;
    margin: 0 auto;
  }
  .mainbackground > .menuFullWidth > .fullwidthAccount > .formsChange > form {
    width: 35%;
  }
  /* .mainbackground > .menuFullWidth > .sideBar > .box:nth-child(1) {
    margin-bottom: 1rem !important;
  } */
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;EACd;cACY;AACd;AACA;EACE,UAAU;EACV,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;;;;;;;;;EASE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,MAAM;IACN,OAAO;IACP,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;EACrB;EACA;;;;;;;KAOG;EACH;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;EACA;IACE,gCAAgC;EAClC;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;EACrB;EACA;;KAEG;EACH;IACE,gCAAgC;EAClC;EACA;;;;;;;;;KASG;EACH;IACE,qBAAqB;EACvB;EACA;;;;;;;;;;;KAWG;EACH;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;;;;;;;;IAQE,WAAW;EACb;EACA;;;;;;;;;;IAUE,UAAU;EACZ;EACA;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE;qBACiB;IACjB,6BAA6B;EAC/B;EACA;IACE,qBAAqB;EACvB;EACA;;;;;;;;IAQE,qBAAqB;EACvB;EACA;;;;;;;IAOE,oCAAoC;IACpC,4BAA4B;EAC9B;EACA;;;;;;;IAOE,qBAAqB;EACvB;EACA;;;;;;;;;IASE,qCAAqC;IACrC,kCAAkC;EACpC;EACA;;;;;;;IAOE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;;;;;;;;IAQE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;;;;;;;;;IASE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;;;;;;;;;;IAUE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;;;;;;;;IAQE,qBAAqB;IACrB,kBAAkB;IAmBlB;;;;;;;gBAOY;IACZ;;;;;;;gBAOY;IACZ,qBAAqB;IACrB,6BAA6B;EAC/B;EACA;;;;;;;;;IASE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,cAAc;IACd,6BAA6B;EAC/B;EACA;;;;;;;;IAQE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;;;;;;;;IAQE,qBAAqB;EACvB;EACA;;;;;;;;;IASE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;;;;;;;;;;IAUE,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,gCAAgC;EAClC;EACA;;;;;IAKE,UAAU;EACZ;EACA;;;;;;IAME,WAAW;EACb;EACA;IACE,UAAU;IACV,yBAAyB;EAC3B;EACA;;;;;;;;;IASE,UAAU;EACZ;EACA;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;;KAEG;AACL","sourcesContent":["html {\n  scroll-behavior: smooth;\n}\n.mainbackground {\n  width: 100%;\n  min-height: 100vh;\n  padding-top: 6rem;\n}\n.mainbackground > .notCont {\n  width: 90%;\n  margin: 0 auto;\n  padding-bottom: 4rem;\n}\n.mainbackground > .loginscheme {\n  width: 90%;\n  margin: 0 auto;\n}\n.mainbackground > .notification {\n  width: 90%;\n  margin: 0 auto;\n  /* position: relative;\n  top: 7rem; */\n}\n.mainbackground > .menu {\n  width: 90%;\n  margin: 0 auto;\n  /* padding-top: 5rem; */\n}\n.mainbackground > .menu > div > .image {\n  border-radius: 1rem;\n  transform: rotate(-45deg);\n}\n.mainbackground > .menu > div > .image > img {\n  height: 150px;\n  width: 150px;\n  transform: rotate(45deg);\n  object-fit: contain;\n}\n.mainbackground > .registerLogo > .image {\n  border-radius: 1rem;\n  transform: rotate(-45deg);\n}\n.mainbackground > .registerLogo > .image > img {\n  height: 150px;\n  width: 150px;\n  transform: rotate(45deg);\n  object-fit: contain;\n}\n.mainbackground > .homeLogo > .image {\n  border-radius: 1rem;\n  transform: rotate(-45deg);\n}\n.mainbackground > .homeLogo > .image > img {\n  height: 150px;\n  width: 150px;\n  transform: rotate(45deg);\n  object-fit: contain;\n}\n.mainbackground > .menu > .content:nth-child(2) {\n  width: 100%;\n  border-bottom: 1px solid #4a4a4a;\n}\n.mainbackground > .menu > .content:nth-child(3) {\n  width: 100%;\n}\n.mainbackground > .menu > .content:nth-child(3) > .apps > div {\n  width: 100%;\n}\n.mainbackground > .menu > .content:nth-child(3) > .apps > a {\n  width: 50%;\n}\n.mainbackground > .menu > .content:nth-child(3) > .apps > a > span {\n  border-radius: 0.4rem;\n}\n.mainbackground\n  > .menu\n  > .content:nth-child(3)\n  > div\n  > .box\n  > .table\n  > tbody\n  > tr\n  > td:nth-child(2) {\n  width: 30%;\n}\n.mainbackground > .menu > .box {\n  width: 100%;\n}\n.mainbackground > .menu > .formsChange {\n  width: 100%;\n}\n.mainbackground > .menu > .accountInfo {\n  border-bottom: 1px solid #4a4a4a;\n  width: 100%;\n}\n.mainbackground > .menu > .accountInfo > .buttons > div {\n  width: 100%;\n}\n.mainbackground > .mobile > .modal-content {\n  width: 90%;\n  margin: 0 auto;\n}\n.mainbackground > .menu .adminConfMob {\n  border-top: 1px solid #4a4a4a;\n}\n\n@media screen and (min-width: 1024px) {\n  .mainbackground > .notCont {\n    width: 50%;\n    margin: 0 auto;\n  }\n  .mainbackground > .loginscheme {\n    width: 40%;\n    margin: 0 auto;\n  }\n  .mainbackground > .menuFullWidth {\n    width: 100%;\n    height: 100%;\n  }\n  .mainbackground > .menuFullWidth > .sideBar {\n    position: fixed;\n    padding-top: 6rem;\n    top: 0;\n    left: 0;\n    width: 20%;\n    min-height: 100vh;\n  }\n  .mainbackground > .menuFullWidth > .sideBar > .topSideBar {\n    width: 100%;\n  }\n  .mainbackground > .menuFullWidth > .sideBar > .topSideBar > .image {\n    border-radius: 1rem;\n    transform: rotate(-45deg);\n  }\n  .mainbackground > .menuFullWidth > .sideBar > .topSideBar > .image > img {\n    height: 100px;\n    width: 100px;\n    transform: rotate(45deg);\n    object-fit: contain;\n  }\n  /* .mainbackground > .menuFullWidth > .sideBarRight {\n    position: fixed;\n    padding-top: 6rem;\n    top: 0;\n    left: 80%;\n    width: 20%;\n    min-height: 100vh;\n  } */\n  .mainbackground > .menuFullWidth > div {\n    position: relative;\n    left: 20%;\n    width: 80%;\n  }\n  .mainbackground > .menuFullWidth > div > .content > .topTitle {\n    border-bottom: 1px solid #4a4a4a;\n  }\n  .mainbackground > .menuFullWidth > div > .content > div {\n    width: 100%;\n  }\n  .mainbackground > .menuFullWidth > div > .content > div > .image {\n    border-radius: 1rem;\n    transform: rotate(-45deg);\n  }\n  .mainbackground > .menuFullWidth > div > .content > div > .image > img {\n    height: 200px;\n    width: 200px;\n    transform: rotate(45deg);\n    object-fit: contain;\n  }\n  /* .mainbackground > .menuFullWidth > div > .content > .table {\n    border-radius: 1rem;\n  } */\n  .mainbackground > .menuFullWidth > .content > div > .subtitle:nth-child(3) {\n    border-bottom: 1px solid #4a4a4a;\n  }\n  /* .mainbackground > .menuFullWidth > .sideBar > .sidebarmenu {\n    width: 90%;\n    margin: 0 auto;\n    padding-top: 1rem;\n  }\n  .mainbackground > .menuFullWidth > .sideBar > .sidebarmenu > .box {\n    width: 90%;\n    margin: 0 auto;\n    cursor: pointer;\n  } */\n  .mainbackground > .menuFullWidth > .sideBar > .topSideBar > .asideMenu {\n    width: 80% !important;\n  }\n  /* .mainbackground > .menuFullWidth > .sideBar > .sidebarmenu {\n    border-top: 1px solid #4a4a4a;\n    border-bottom: 1px solid #4a4a4a;\n  }\n  .mainbackground > .menuFullWidth > .sideBar > .sidebarmenu > .box:hover {\n    background: #7a7a7a !important;\n    transition: 0.3s ease-in-out;\n  }\n  .mainbackground > .menuFullWidth > .sideBar > .sidebarmenu > .selectedCard {\n    background: #7a7a7a !important;\n    transition: 0.3s ease-in-out;\n  } */\n  .mainbackground > .menuFullWidth > div > .content {\n    width: 90%;\n    margin: 0 auto;\n  }\n  .mainbackground > .menuFullWidth > div > .content > div > .box {\n    border: 1px solid #4a4a4a;\n    width: 60%;\n  }\n  .mainbackground > .menuFullWidth > div > .content > div > .adminConf {\n    width: 30%;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > div\n    > .content\n    > div\n    > .adminConf\n    > div\n    > .explanation {\n    width: 100%;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > div\n    > .content\n    > div\n    > .box\n    > .table\n    > tbody\n    > tr\n    > td:nth-child(1) {\n    width: 70%;\n  }\n  .mainbackground > .menuFullWidth > div > .content > .box {\n    width: 90%;\n    margin: 0 auto;\n  }\n  .mainbackground > .menuFullWidth > div > .content > .buttons {\n    /* width: 90%;\n    margin: 0 auto; */\n    border-top: 1px solid #4a4a4a;\n  }\n  .mainbackground > .menuFullWidth > div > .content > .apps > a > .icon-text {\n    border-radius: 0.4rem;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > div\n    > .content\n    > .box\n    > form\n    > .content\n    > div {\n    border-radius: 0.5rem;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .sideBar\n    > div\n    > .socialmedialinks\n    > a\n    > .icon-text:hover {\n    /* background: #dbdbdb !important; */\n    transition: 0.3s ease-in-out;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .sideBar\n    > div\n    > .socialmedialinks\n    > a\n    > .icon-text {\n    border-radius: 0.3rem;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .sideBar\n    > div\n    > .socialmedialinks\n    > a:nth-child(1)\n    > .icon-text\n    > .icon\n    > svg {\n    transform: scale(1.2, 1.2) !important;\n    /* transition: 0.3s ease-in-out; */\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .sideBar\n    > div\n    > .socialmedialinks\n    > a\n    > .icon-text {\n    height: 39px !important;\n    width: 39px !important;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .sideBar\n    > div\n    > .socialmedialinks\n    > a\n    > .icon-text\n    > .icon {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .sideBar\n    > div\n    > .socialmedialinks\n    > a\n    > .icon-text\n    > .icon\n    > svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .sideBar\n    > div\n    > .socialmedialinks\n    > a\n    > .icon-text\n    > .icon\n    > svg\n    > path {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .sideBar\n    > div\n    > .socialmedialinks\n    > a:nth-child(2)\n    > .icon-text\n    > .icon {\n    border-radius: 0.3rem;\n    color: transparent;\n    background: -webkit-radial-gradient(\n      30% 107%,\n      circle,\n      #fdf497 0%,\n      #fdf497 5%,\n      #fd5949 45%,\n      #d6249f 60%,\n      #285aeb 90%\n    ) !important;\n    background: -o-radial-gradient(\n      30% 107%,\n      circle,\n      #fdf497 0%,\n      #fdf497 5%,\n      #fd5949 45%,\n      #d6249f 60%,\n      #285aeb 90%\n    ) !important;\n    background: radial-gradient(\n      circle at 30% 107%,\n      #fdf497 0%,\n      #fdf497 5%,\n      #fd5949 45%,\n      #d6249f 60%,\n      #285aeb 90%\n    ) !important;\n    background: -webkit-radial-gradient(\n      circle at 30% 107%,\n      #fdf497 0%,\n      #fdf497 5%,\n      #fd5949 45%,\n      #d6249f 60%,\n      #285aeb 90%\n    ) !important;\n    background-clip: text;\n    -webkit-background-clip: text;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .sideBar\n    > div\n    > .socialmedialinks\n    > a:nth-child(2)\n    > .icon-text\n    > .icon\n    > svg {\n    color: #ffffff;\n  }\n  .mainbackground > .menuFullWidth > .sideBar > div {\n    width: 100%;\n  }\n  .mainbackground > .menuFullWidth > .sideBar > div > .emailLink {\n    width: 90%;\n    margin: 0 auto;\n    border-top: 1px solid #4a4a4a;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .sideBar\n    > div\n    > .emailLink\n    > div\n    > a\n    > .icon-text {\n    height: 39px !important;\n    width: 39px !important;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .sideBar\n    > div\n    > .emailLink\n    > div\n    > a\n    > .icon-text {\n    border-radius: 0.4rem;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .sideBar\n    > div\n    > .emailLink\n    > div\n    > a\n    > .icon-text\n    > .icon {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .sideBar\n    > div\n    > .emailLink\n    > div\n    > a\n    > .icon-text\n    > .icon\n    > svg {\n    height: 100% !important;\n    width: 90% !important;\n  }\n  .mainbackground > .menuFullWidth > .fullwidthAccount > .accountInfo {\n    width: 90%;\n    margin: 0 auto;\n  }\n  .mainbackground > .menuFullWidth > .fullwidthAccount > .accountInfo {\n    border-bottom: 1px solid #4a4a4a;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .fullwidthAccount\n    > .accountInfo\n    > .buttons {\n    width: 25%;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .fullwidthAccount\n    > .accountInfo\n    > .buttons\n    > div {\n    width: 100%;\n  }\n  .mainbackground > .menuFullWidth > .fullwidthAccount > .accountInfo > .box {\n    width: 60%;\n    border: 1px solid #4a4a4a;\n  }\n  .mainbackground\n    > .menuFullWidth\n    > .fullwidthAccount\n    > .accountInfo\n    > .box\n    > .table\n    > tbody\n    > tr\n    > td:nth-child(1) {\n    width: 20%;\n  }\n  .mainbackground > .menuFullWidth > .fullwidthAccount > .formsChange {\n    width: 90%;\n    margin: 0 auto;\n  }\n  .mainbackground > .menuFullWidth > .fullwidthAccount > .formsChange > form {\n    width: 35%;\n  }\n  /* .mainbackground > .menuFullWidth > .sideBar > .box:nth-child(1) {\n    margin-bottom: 1rem !important;\n  } */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
